<template>
  <v-card
    class="py-6 px-2 white"
    outlined
    :style="{ height: '100%', width: '100%' }"
    :elevation="5"
  >
    <div class="title-tag-cloud mb-3">{{ title }}</div>
    <vue-word-cloud
      :style="{ height: '90%', width: '80%', margin: 'auto' }"
      :words="words"
      :font-family="fontFamily"
      :color="([, weight]) => colorRender(weight)"
      :rotation-unit="'turn'"
      :rotation="0"
      :spacing="1"
      :font-size-ratio="4"
      :animation-overlap="2"
      :animation-duration="2000"
    >
      <template slot-scope="{ text }">
        <div style="cursor: pointer">
          {{ text }}
        </div>
      </template>
    </vue-word-cloud>
    <!-- 
    <vue-word-cloud
      :style="{ height: '90%', width: '80%', margin: 'auto' }"
      :words="words"
      rotation-unit="turn"
      :rotation="0"
      :color="([, weight]) => colorRender(weight)"
      :font-size-ratio="5"
      :spacing="1"
      :font-family="fontFamily"
      :animation-overlap="5"
      :animation-duration="700"
    >
      <template slot-scope="{ text, weight, word }">
        <div :title="weight" style="cursor: pointer" @click="onWordClick(word)">
          {{ text }}
        </div>
      </template>
    </vue-word-cloud> -->
  </v-card>
</template>

<script>
import VueWordCloud from 'vuewordcloud'

import variables from '@/styles/variables.scss'

export default {
  name: 'tagCloud',
  components: {
    [VueWordCloud.name]: VueWordCloud
  },
  props: {
    title: String,
    words: Array,
    maxValue: Number
  },
  mounted() {},
  data() {
    return {
      fontFamily: variables.fontFamily,
      color: ['#D73A38', '#3a7ceb', '#00897B', '#8d6e63', '#F4B400']
    }
  },
  methods: {
    colorRender() {
      return this.color[this.randomInteger(0, this.color.length - 1)]
    },
    randomInteger(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min
    }
  }
}
</script>
